import { FC } from 'react';
import Logo from '../../../../common/logo/logo';
import translation from '../../../../languages';
import './header.scss';
import classNames from '../../../../utils/classnames';
import useIsMobile from '../../../../hooks/use-is-mobile';
import FontAwesomeIcon from '../../../../ui/font-awesome-icon/font-awesome-icon';

const Header: FC<TranslationProps> = ({ t }) => {
    const mobile = useIsMobile();

    if (mobile) {
        return (
            <div className='payment-header flex-column d-flex align-items-center justify-content-center'>
                <span className='tsc-body-highlighted pay-text-block'>
                    <div className='d-flex align-items-center'>
                        <FontAwesomeIcon className='mr-1' width={32} height={32} name='lock' />{' '}
                        <span className='tsc-h3'>{t('payment.payNowSecure')}</span>
                    </div>
                </span>
                <div className='separator' />
            </div>
        );
    }

    return (
        <div className={classNames('header payment-header d-flex align-items-center')}>
            <Logo className='logo' />
            <div className='checkout-tabs'>
                <div className='tab active'>
                    <span className='tsc-body-highlighted pay-text-block'>
                        <div className='d-flex align-content-center'>
                            <FontAwesomeIcon className='mr-1' width={32} height={32} name='lock' />{' '}
                            <span className='tsc-h3'>{t('payment.payNowSecure')}</span>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    );
};

const translate = translation('payment');

export default translate(Header);
